import { Button, Divider, List, ListItem, Modal, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import PlanIcon from 'Components/Icons/PlanIcon';
import TeamMemberIcon from 'Components/Icons/TeamMemberIcon';
import RealTimeIcon from 'Components/Icons/RealTimeIcon';
import UnlimitedIcon from 'Components/Icons/UnlimitedIcon';
import { pricingPlanCardItems } from './pricing-constants';
import { formatDateToDMYYYY } from 'helper/date.helper';
const { capitalizeFirstLetter } = require('helper/string.helper');
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '540px',
    bgcolor: 'background.paper',
    padding: '30px 20px',
    borderRadius: '12px',
    maxHeight: '100vh',
    overflow: 'hidden auto',

    '@media screen and (min-width: 768px)': {
        padding: '32px 40px 40px'
    }
};
const ReactivateModal = ({
    open,
    handleClose,
    planName,
    paymentAmount,
    renewDate,
    newSelectedPlan,
    newSelectedPriceId,
    onHandleClickUpdatePlan
}) => {
    const newPlan = capitalizeFirstLetter(planName || '');
    const newPaymentAmount = pricingPlanCardItems?.at(1)?.amount?.[paymentAmount] || '399';
    const date1 = new Date();
    const date2 = new Date(renewDate);
    var Difference_In_Time = date2.getTime() - date1.getTime();
    var Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
    const handleUpatePlan = () => {
        onHandleClickUpdatePlan(newSelectedPlan, newSelectedPriceId);
        handleClose();
    };
    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h2" component="h2" fontWeight="600" mb={3} color="#212121">
                    What you’re getting with {capitalizeFirstLetter(newPlan || '')}
                </Typography>
                <List
                    sx={{
                        margin: '0 0 24px',
                        padding: '0',
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '24px',
                        '& .MuiListItem-root': {
                            padding: '0 0 0 36px',
                            display: 'block',
                            position: 'relative',
                            color: '#00214D',
                            minHeight: '24px',
                            fontSize: '1rem',
                            lineHeight: '1.4375',

                            svg: {
                                position: 'absolute',
                                top: '0',
                                left: '0'
                            }
                        }
                    }}
                >
                    <ListItem>
                        <TeamMemberIcon />
                        Unlimited team member access
                    </ListItem>
                    <ListItem>
                        <UnlimitedIcon />
                        Complete and unlimited access to the <strong>Question registry</strong>
                    </ListItem>
                    <ListItem>
                        <RealTimeIcon />
                        Exclusive access to reports, question assigning, and real-time <strong>investor sentiment score</strong>
                    </ListItem>
                </List>

                <Stack rowGap="12px" mb={1}>
                    <Button className="alternate color-white" onClick={handleClose}>
                        Nevermind
                    </Button>
                    <Button className="alternate-reversed" onClick={handleUpatePlan}>
                        I don't want {newPlan}
                    </Button>
                </Stack>

                <Typography color="#7D7D82" fontSize="0.75rem" textAlign="center">
                    You&apos;ll still have access to {newPlan} for the remaining days of your current plan.
                </Typography>

                <Divider sx={{ margin: '24px 0', borderColor: '#FBB414' }} />

                <List
                    sx={{
                        padding: '0',
                        margin: '0',
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '16px',
                        '& .MuiListItem-root': {
                            padding: '0',
                            justifyContent: 'space-between',

                            '> span': {
                                fontSize: '1rem',
                                lineHeight: '1.25',
                                fontWeight: '500',
                                color: '#00214D',

                                '&:first-child': {
                                    paddingLeft: '40px',
                                    position: 'relative',

                                    svg: {
                                        position: 'absolute',
                                        top: '0',
                                        left: '0',
                                        width: '24px'
                                    }
                                },
                                '&:last-child': {
                                    textAlign: 'right'
                                }
                            }
                        }
                    }}
                >
                    <ListItem>
                        <Typography component="span">
                            <PlanIcon />
                            Current plan:
                        </Typography>
                        <Typography component="span">
                            {Difference_In_Days} days of {newPlan}
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography component="span">Payment amount:</Typography>
                        <Typography component="span">${newPaymentAmount}</Typography>
                    </ListItem>
                    <ListItem>
                        <Typography component="span">Renews:</Typography>
                        <Typography component="span">{formatDateToDMYYYY(renewDate)}</Typography>
                    </ListItem>
                </List>
            </Box>
        </Modal>
    );
};
export default ReactivateModal;
